import u from "./ghl-ui.es1589.js";
import f from "./ghl-ui.es1590.js";
import a from "./ghl-ui.es1586.js";
import l from "./ghl-ui.es1587.js";
import c from "./ghl-ui.es1588.js";
import n from "./ghl-ui.es1591.js";
import { Parser as h } from "./ghl-ui.es1670.js";
import { parseNDigitsSigned as m } from "./ghl-ui.es1671.js";
var Y = /* @__PURE__ */ function(p) {
  l(o, p);
  var s = c(o);
  function o() {
    var e;
    u(this, o);
    for (var r = arguments.length, t = new Array(r), i = 0; i < r; i++)
      t[i] = arguments[i];
    return e = s.call.apply(s, [this].concat(t)), n(a(e), "priority", 130), n(a(e), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), e;
  }
  return f(o, [{
    key: "parse",
    value: function(r, t) {
      return t === "u" ? m(4, r) : m(t.length, r);
    }
  }, {
    key: "set",
    value: function(r, t, i) {
      return r.setUTCFullYear(i, 0, 1), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), o;
}(h);
export {
  Y as ExtendedYearParser
};
